import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { debounce } from 'core/utils/time';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
export var TABLET_MIN_WIDTH = 768;
export var LAPTOP_MIN_WIDTH = 992;
export var DESKTOP_MIN_WIDTH = 1200;
export default function useWindowSize() {
  function getSize() {
    if (!true) {
      return {
        width: 0,
        height: 0
      };
    }

    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  var _useState = useState(getSize),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  var isMobile = useMemo(function () {
    return windowSize.width < TABLET_MIN_WIDTH;
  }, [windowSize.width]);
  var isTablet = useMemo(function () {
    return windowSize.width >= TABLET_MIN_WIDTH && windowSize.width < LAPTOP_MIN_WIDTH;
  }, [windowSize.width]);
  var isLaptop = useMemo(function () {
    return windowSize.width >= LAPTOP_MIN_WIDTH && windowSize.width < DESKTOP_MIN_WIDTH;
  }, [windowSize.width]);
  var isDesktop = useMemo(function () {
    return windowSize.width >= DESKTOP_MIN_WIDTH;
  }, [windowSize.width]);
  useEffect(function () {
    // Debounce to avoid the function fire multiple times
    var handleResizeDebounced = debounce(function handleResize() {
      setWindowSize(getSize());
    }, 50);
    window.addEventListener('resize', handleResizeDebounced);
    return function () {
      return window.removeEventListener('resize', handleResizeDebounced);
    };
  }, []);
  return _objectSpread(_objectSpread({}, windowSize), {}, {
    isMobile: isMobile,
    isTablet: isTablet,
    isLaptop: isLaptop,
    isDesktop: isDesktop
  });
}
export var WindowSizeContext = /*#__PURE__*/createContext({
  width: 0,
  height: 0,
  isMobile: false,
  isTablet: false,
  isLaptop: false,
  isDesktop: false
});
export function getWindowSize() {
  return useContext(WindowSizeContext);
}